// extracted by mini-css-extract-plugin
export default {"footerToolbar":"_31yCC","footerToolbar_buttons":"PDdfC","footerToolbarButtons":"PDdfC","wrapper":"_1phPJ","desktop":"ylX64","editor":"_30yE8","atomic":"_1yuX_"};